export const generateUUID = () => {
  // Create an array of 16 bytes
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);

  // Set bits for version and variant according to RFC4122
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // UUID version 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // UUID variant 10xxxxxx

  const byteToHex = Array.from({ length: 256 }, (_, i) =>
    i.toString(16).padStart(2, "0")
  );

  const hex = Array.from(bytes, (b) => byteToHex[b]);

  return [
    hex.slice(0, 4).join(""),
    hex.slice(4, 6).join(""),
    hex.slice(6, 8).join(""),
    hex.slice(8, 10).join(""),
    hex.slice(10, 16).join(""),
  ].join("-");
};
